module.exports = __webpack_public_path__ + "static/media/user_data_dropdown_icon.8e9cf5ef.svg";